import { createFileRoute, Link, notFound } from '@tanstack/react-router'
import { useSuspenseQuery } from '@tanstack/react-query'
import { XCircleIcon } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { FeedbackForm } from '@/features/feedback/FeedbackForm'
import { feedbackStayQueryOptions } from '@/features/feedback/feedbackApi'
import { HttpError } from '@/api/http'
import { SITE_NAME, noindexMeta } from '@/lib/seo/siteMeta'

export const Route = createFileRoute('/_layout/hodnoceni/$orderNumber/$token')({
  component: FeedbackPage,
  errorComponent: FeedbackErrorComponent,
  notFoundComponent: FeedbackErrorComponent,
  loader: async ({ context, params }) => {
    try {
      await context.queryClient.query({
        ...feedbackStayQueryOptions(params.orderNumber, params.token),
        staleTime: 'static',
      })
    } catch (error) {
      // A dead feedback link must surface as a real 404, not an SSR 500.
      if (error instanceof HttpError && error.status === 404) {
        throw notFound()
      }
      throw error
    }
  },
  head: () => ({
    meta: [{ title: `Hodnocení pobytu | ${SITE_NAME}` }, ...noindexMeta()],
  }),
})

function FeedbackPage() {
  const { orderNumber, token } = Route.useParams()
  const { data } = useSuspenseQuery(feedbackStayQueryOptions(orderNumber, token))

  return (
    <div className="container flex min-h-[50vh] flex-col items-center justify-center py-16">
      <FeedbackForm orderNumber={orderNumber} token={token} stay={data} />
    </div>
  )
}

function FeedbackErrorComponent() {
  return (
    <div className="container flex min-h-[50vh] flex-col items-center justify-center py-16 text-center">
      <XCircleIcon className="mb-4 h-12 w-12 text-red-500" />
      <h1 className="mb-2 text-2xl font-semibold text-slate-700">Odkaz nefunguje</h1>
      <p className="mb-6 max-w-sm text-slate-500">
        Zkuste prosím otevřít odkaz z e-mailu znovu, nebo nám napište na info@matevolno.cz.
      </p>
      <Button asChild>
        <Link to="/">Zpět na hlavní stránku</Link>
      </Button>
    </div>
  )
}
